import {
    addToChainBefore,
    Handler, HasOnSuccess} from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { AddOrUpdateShipTo, chain } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { getCartPoNumberState } from "@ucs/Store/CustomSelectors";

type HandlerType = Handler<
    HasOnSuccess,
    {
        shipTo?: ShipToModel;
        updatedBillTo?: BillToModel;
        updatedShipTo?: ShipToModel;
        cart: Cart;
        apiParameter: UpdateCartApiParameter;
        apiResult: CartResult;
    }
>;
export const PopulatePoNumber: HandlerType = props => {
    const state: any = props.getState();
    const { cartId } = state.pages.checkoutShipping;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart available while trying to update the current cart.");
    }
    const number = getCartPoNumberState(state) || "";
    const poNumber = number === "" ? cart.poNumber : number;

    props.apiParameter.cart.poNumber = poNumber;
};

addToChainBefore(chain, AddOrUpdateShipTo, PopulatePoNumber);